import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-infrastructure-overview-section',
  standalone: true,
  templateUrl: './infrastructure-overview-section.component.html',
  styleUrl: './infrastructure-overview-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfrastructureOverviewSectionComponent {
  public title = input.required<string>();
}
